module.exports = __webpack_public_path__ + "static/media/nie-czas-na-nude_small.4b5e1aa8.jpg";